import React from 'react'

import { localizer } from '../../Translator'

import TableBody from '@material-ui/core/TableBody'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import Paper from '@material-ui/core/Paper'
import { Grid } from "@material-ui/core"
import Container from '@material-ui/core/Container'
import { Backdrop, CircularProgress } from "@material-ui/core"
import Typography from '@material-ui/core/Typography'
import { Button } from "@material-ui/core"
import IconButton from '@material-ui/core/IconButton'
import Collapse from '@material-ui/core/Collapse'
import Checkbox from '@material-ui/core/Checkbox'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemText from '@material-ui/core/ListItemText'
import Pagination from '@material-ui/lab/Pagination'
import PaginationItem from '@material-ui/lab/PaginationItem'

import { GridHeaderFilter } from '../common/HeaderComponentStyled.js'
import { TableRowHeaderStyled,TableRowStyled, TableCellStyled } from '../common/TableStyled.js'
import { TableStyled } from '../common/TableStyled.js'
import { TextFieldStyled } from "../common/InputStyled";
import ScreenHeading from '../common/ScreenHeading.js'

import OutboxCli from "../../sdk/OutboxCli";
import AuthCli from '../../sdk/AuthCli.js';
import ProductCli from '../../sdk/ProductCli.js';

import Roles from "../Utilities/Roles.js"
import CurrencyCustom from '../Utilities/CurrencyCustom.js';
import { SnackbarCustom } from "../Utilities/SnackbarCustom";

import { ShipmentSavedRow } from "./sections/ShipmentSavedRow";
import ReportCli from "../../sdk/ReportCli.js";

const SHIPMENT_PAGE_SIZE = 50
const SHIPMENT_PAGE_SIZE_OPTIONS = [50, 100, 200]
const USERS_PAGE_SIZE = 999999
const INITAL_FILTERS = {
  productCode: [],
  reference: null,
  postalCode: null,
  locality: null,
  who: null
}

/**
 * Class component that represents the shipments list table.
 */
export class ShipmentsSavedLayout extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      /* No emitted shipment list */
      shipments: [],

      pagesLoaded: 0,
      endOfShipments: false,
      pageSize: SHIPMENT_PAGE_SIZE,
      maxKnownPage: 0,

      isLoading: false,

      // List of products to filter
      products: [],

      // Product selected in autocomplete filter
      productSelected: [],
      isAllProductsSelected: true,

      shipmentRemoveError: null,
      shipmentsError: null,

      //filter
      filters: INITAL_FILTERS,

      totalShipments: 0,
      open: false,

      // List of shipment selected by user/client
      shipmentsCodesSelected: [],
      checkedAll: true,

      //users to filter
      users: [],
      usersSelected: [],
      isAllUsersSelected: true,
      usersError: null,
    }
  }

  /**
   * It runs after the component output has been rendered to the DOM.
   * Get first 1000 shipments.
   */
  componentDidMount() {

    AuthCli.GetSessionInfo().then(session => {
      if (session) {
        this.setState({ session: session }, () => {
          this.getAllProducts()
          if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
            this.getBillableUsers()
          }

          this.loadShipmentsByRole(this.state.filters, true)
        })
      }
    })
  }

  getShipments = async (filters, includeCount = false) => {
    this.setState({ isLoading: true })

    if (includeCount) {
      await this.getShipmentsCount(filters)
    }

    await OutboxCli.GetShipments(this.state.pageSize, this.state.pagesLoaded, false, false, true, filters).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentsError: data.substring(data.indexOf(' ')) })
      } else {
        const shipments = Array.isArray(data) ? data : []
        const shipmentcodes = shipments.map(s => s.shipmentCode)
        const shipmentsCodesSelected = this.state.checkedAll ? shipmentcodes : []
        const maxKnownPage = this.getMaxPageFromCount()

        this.setState({
          shipments: shipments,
          shipmentsCodesSelected: shipmentsCodesSelected,
          endOfShipments: this.state.pagesLoaded >= maxKnownPage,
          maxKnownPage: maxKnownPage,
          shipmentsError: null
        })
      }
      this.setState({ isLoading: false })
    })
  }

  getShipmentsOfBillable = async (filters, includeCount = false) => {
    this.setState({ isLoading: true })

    if (includeCount) {
      await this.getShipmentsCount(filters)
    }

    await OutboxCli.GetShipmentsOfBillable(this.state.pageSize, this.state.pagesLoaded, false, false, true, filters).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentsError: data.substring(data.indexOf(' ')) })
      } else {
        const shipments = Array.isArray(data) ? data : []
        const shipmentcodes = shipments.map(s => s.shipmentCode)
        const shipmentsCodesSelected = this.state.checkedAll ? shipmentcodes : []
        const maxKnownPage = this.getMaxPageFromCount()

        this.setState({
          shipments: shipments,
          shipmentsCodesSelected: shipmentsCodesSelected,
          endOfShipments: this.state.pagesLoaded >= maxKnownPage,
          maxKnownPage: maxKnownPage,
          shipmentsError: null
        })
      }
      this.setState({ isLoading: false })
    })
  }

  getShipmentsCount = async (filters) => {
    let response = null

    if (this.state.session.role === Roles.ROLE_USER.Name) {
      response = await OutboxCli.CountShipments(false, false, true, filters)
    } else if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      response = await OutboxCli.CountShipmentsOfBillable(false, false, true, filters)
    }

    if (response !== null && response !== undefined && response.toString().startsWith("[ERR")) {
      this.setState({ shipmentsError: response.substring(response.indexOf(' ')), totalShipments: 0 })
      return 0
    }

    const total = Number(response)
    const safeTotal = Number.isFinite(total) && total >= 0 ? total : 0

    this.setState({ totalShipments: safeTotal }, () => {
      const maxKnownPage = this.getMaxPageFromCount()
      if (this.state.maxKnownPage !== maxKnownPage) {
        this.setState({ maxKnownPage: maxKnownPage })
      }
    })

    return safeTotal
  }

  loadShipmentsByRole = (filters, includeCount = false) => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      return this.getShipments(filters, includeCount)
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      return this.getShipmentsOfBillable(filters, includeCount)
    }

    return null
  }

  // Computes the last available page index (0-based) from total results and current page size.
  getMaxPageFromCount = () => {
    const total = Number(this.state.totalShipments || 0)
    const pageSize = Number(this.state.pageSize || SHIPMENT_PAGE_SIZE)
    if (total <= 0 || pageSize <= 0) return 0

    return Math.max(Math.ceil(total / pageSize) - 1, 0)
  }

  // Handles page navigation while keeping current filter values.
  handleChangePage = (newPage) => {
    const maxPage = this.getMaxPageFromCount()
    if (newPage < 0 || newPage > maxPage) return

    this.setState({
      pagesLoaded: newPage,
      checkedAll: true,
      shipmentsCodesSelected: []
    }, () => {
      this.loadShipmentsByRole(this.state.filters, false)
    })
  }

  // Updates page size, resets paging to first page, and reloads current query.
  handleChangeRowsPerPage = (event) => {
    const newPageSize = parseInt(event.target.value, 10)

    this.setState({
      pageSize: Number.isFinite(newPageSize) ? newPageSize : SHIPMENT_PAGE_SIZE,
      pagesLoaded: 0,
      maxKnownPage: 0,
      checkedAll: true,
      shipmentsCodesSelected: []
    }, () => {
      this.loadShipmentsByRole(this.state.filters, true)
    })
  }

  // Getting list of product to visualize product description instead of productCode
  getAllProducts = async () => {
    ProductCli.GetAllProducts().then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ productError: response.substring(response.indexOf(' ')) })
      } else {
        // product selectors are ordered by their display name.
        const sortedProducts = Array.isArray(response)
          ? [...response].sort((a, b) => (a.description || '').localeCompare((b.description || ''), 'es', { sensitivity: 'base' }))
          : []
        this.setState({ products: sortedProducts, productSelected: sortedProducts })
      }
    })
  }

  getBillableUsers = () => {
    AuthCli.GetBillableUsers(USERS_PAGE_SIZE, 0).then(response => {
      if (response !== null && response.toString().startsWith("[ERR")) {
        this.setState({ usersError: response.substring(response.indexOf(' ')) })
      }
      else {
        response = response.filter(function (element) {
          return element !== undefined;
        })
        this.setState({ users: response.sort(this.GetSortOrder("userEmail")), usersSelected: response, usersError: null })
      }
    })
    
  }

  /**
   Removes or cancels a shipment owned by the calling user.
  **/
  removeOrCancelShipment = (shipment) => {

    if (this.state.session.userEmail.toLowerCase() !== shipment.ownerUser.toLowerCase()) return
    
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.removeShipment(shipment, true)
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.removeShipmentOfBillable(shipment, true)
      return
    }
  }

  removeShipment = (shipment, removeDraft, doNotCancel) => {
    this.setState({ isLoading: true })
    OutboxCli.RemoveShipment(shipment.shipmentId, removeDraft, doNotCancel).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentRemoveError: data.substring(data.indexOf(' ')) })
      } else {
        let shipments = this.state.shipments.filter(s => s.shipmentId !== shipment.shipmentId)
        let totalshipments = this.state.totalShipments - 1
        this.setState({ shipments: shipments, totalShipments: totalshipments, shipmentRemoveError: null },
          () => {
            let shipmentcodes = []
            if (this.state.checkedAll) shipmentcodes = this.state.shipments.map(s => { return s.shipmentCode })
            this.setState({ shipmentsCodesSelected: shipmentcodes })
          })
      }
      this.setState({ isLoading: false })
    })
  }

  removeShipmentOfBillable = (shipment, removeDraft, doNotCancel) => {
    this.setState({ isLoading: true })
    OutboxCli.RemoveShipmentOfBillable(shipment.shipmentId, removeDraft, doNotCancel).then(data => {
      if (data !== null && data.toString().startsWith("[ERR")) {
        this.setState({ shipmentRemoveError: data.substring(data.indexOf(' ')) })
      } else {
        let shipments = this.state.shipments.filter(s => s.shipmentId !== shipment.shipmentId)
        let totalshipments = this.state.totalShipments - 1
        this.setState({ shipments: shipments, totalShipments: totalshipments, shipmentRemoveError: null },
          () => {
            let shipmentcodes = []
            if (this.state.checkedAll) shipmentcodes = this.state.shipments.map(s => { return s.shipmentCode })
            this.setState({ shipmentsCodesSelected: shipmentcodes })
          })
      }
      this.setState({ isLoading: false })
    })
  }

  /** Adds or removes all shipment codes to shipment codes selected list */
  onChangeSelectAll = (event) => {
    this.setState({ [event.target.name]: event.target.checked }, () => {
      let shipmentcodes = []
      if (this.state.checkedAll) shipmentcodes = this.state.shipments.map(s => { return s.shipmentCode })
      this.setState({ shipmentsCodesSelected: shipmentcodes })
    })
  }

  /**
   * Adding/Removing a shipment code to shipment codes selected list when row checkbox is checked/unchecked
   * @param {*} shipmentcode code of the shipment to add/remove
   * @param {*} option CHECKED/UNCHECKED option to determinate if the action to apply is add or remove
   */
  addOrRemoveSelectedShipment = (shipmentcode, option) => {
    let shipmentsCodesSelected = [...this.state.shipmentsCodesSelected]
    if (option === 'CHECKED') {
      shipmentsCodesSelected.push(shipmentcode)
    } else {
      shipmentsCodesSelected = shipmentsCodesSelected.filter(shipmentCode => shipmentCode !== shipmentcode)
    }
    this.setState({ shipmentsCodesSelected: shipmentsCodesSelected })
  }
  
  handleonClose = () => {
    this.setState({ shipmentsError: null, shipmentRemoveError: null })
  }

  /** Conditions for those shipments to be included */
  doFilter = () => {
    this.setState({ pagesLoaded: 0, endOfShipments: false, checkedAll: true, shipments: [], shipmentsCodesSelected: [] }, () => {
      this.loadShipmentsByRole(this.state.filters, true)
    })
  }

  /** List of shipment will be reset after clean all filter values */
  doCleanFilters = () => {
    this.setState({
      filters: INITAL_FILTERS, pagesLoaded: 0, endOfShipments: false,
      checkedAll: true, shipments: [], shipmentsCodesSelected: [],
      productSelected: this.state.products, isAllProductsSelected: true,
      usersSelected: this.state.users, isAllUsersSelected: true,
    }, () => {
      this.loadShipmentsByRole(this.state.filters, true)
    })
  }

  /**
  * Set the state open / collapsed of Collapse filter elements .
  */
  setOpen = () => {
    this.setState({ open: !this.state.open })
  }

  /**
   * Handle onChange event to update the state for inputs. 
   */
  onInputchange = (event) => {
    var inputName = event.target.name
    var inputValue = event.target.value

    if (!inputValue) {
      inputValue = null
    }
    
    this.setState(previousState => ({
      filters: {
        ...previousState.filters,
        [inputName]: inputValue
      },
    }))
  }

  /**
   * When user change the product selected 
   */
  handleChangeProduct = async (event) => {
    let valChecked = event.currentTarget.dataset.modal
    if (valChecked === "allProducts") {
      let productSelected = this.state.isAllProductsSelected ? [] : this.state.products
      let productsCodesSelected = this.state.isAllProductsSelected ? [] : this.state.products.map(p => p.productCode);
      this.setState({ productSelected: productSelected, isAllProductsSelected: !this.state.isAllProductsSelected })
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          productCode: productsCodesSelected
        }
      }))
    } else {
      var item = this.state.products.filter(p => p.productCode === valChecked)
      let checked = this.state.productSelected.includes(item[0])
      let productSelected = this.state.productSelected
      
      if (checked) {
        productSelected = this.state.productSelected.filter(p => p.productCode !== valChecked)
      } else {
        productSelected.push(item[0])
      }
      let productsCodesSelected = productSelected.map(p => p.productCode);
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          productCode: productsCodesSelected
        },
        productSelected: productSelected
      }))
    }
  }

  /**
   * When user change the user selected 
   */
  handleChangeUser = async (event) => {
    let valChecked = event.currentTarget.dataset.modal
    if (valChecked === "allUsers") {
      let usersSelected = this.state.isAllUsersSelected ? [] : this.state.users
      let usersIdSelected = this.state.isAllUsersSelected ? [] : this.state.users.map(p => p.userId);
      this.setState({
        usersSelected: usersSelected, isAllUsersSelected: !this.state.isAllUsersSelected,
      })
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          userId: usersIdSelected
        }
      }))
      
    } else {
      var item = this.state.users.filter(p => p.userId === valChecked)
      let checked = this.state.usersSelected.includes(item[0])
      let usersSelected = this.state.usersSelected
      
      if (checked) {
        usersSelected = this.state.usersSelected.filter(p => p.userId !== valChecked)
      } else {
        usersSelected.push(item[0])
      }
     
      let usersIdSelected = usersSelected.map(p => p.userId);
      
      //checks if the user has unchecked/checked the last one he had checked/unchecked to put the "check all" accordingly
      let isAllUsersSelected = this.state.isAllUsersSelected
      if (this.state.users.length === usersSelected.length && usersSelected.length > 0) isAllUsersSelected = true
      if (usersSelected.length === 0) isAllUsersSelected = false
      
      this.setState(previousState => ({
        filters: {
          ...previousState.filters,
          userId: usersIdSelected
        },
        usersSelected: usersSelected,
        isAllUsersSelected: isAllUsersSelected,
      }))
    }
  }


  /**
    * Download to xlsx with the information of shipments selected by user
    * @returns 
    */
  downloadExcel = () => {
    if (this.state.session.role === Roles.ROLE_USER.Name) {
      this.downloadShipmentsExcel(this.state.filters)
      return
    }

    if (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) {
      this.downloadShipmentsOfBillableExcel(this.state.filters)
      return
    }
  }
  
  downloadShipmentsExcel = async (filters) => {
    this.setState({ isLoading: true })
    await ReportCli.DownloadShipmentsReport(false, false, true, filters).then((error) => {
      if (error) this.setState({ shipmentsError: error.substring(error.indexOf(' ')) })
      else this.setState({ shipmentsError: null })
    })
    this.setState({ isLoading: false })
  }

  downloadShipmentsOfBillableExcel = async (filters) => {
    this.setState({ isLoading: true })
    await ReportCli.DownloadShipmentsReportOfBillable(false, false, true, filters).then((error) => {
      if (error) this.setState({ shipmentsError: error.substring(error.indexOf(' ')) })
      else this.setState({ shipmentsError: null })
    })
    this.setState({ isLoading: false })
  }

  /**
   * Sort array of JSON objects based on an attribute
   */
  GetSortOrder(prop) {
    return function (a, b) {
      if (a[prop] > b[prop]) {
        return 1;
      } else if (a[prop] < b[prop]) {
        return -1;
      }
      return 0;
    }
  }
  
  render() {

    // Material-UI pagination works with 1-based pages, while internal state uses 0-based index.
    const totalPages = Math.max(this.getMaxPageFromCount() + 1, 1)
    const currentPage = Math.min(this.state.pagesLoaded + 1, totalPages)
    
    return (
      <React.Fragment>
        <Container maxWidth="xl">

          {/* Screen heading. */}
          <ScreenHeading className="typography-generic" icon={<i className="fa-solid fa-floppy-disk icon-button-header mr-20 ml-20"></i>} title={localizer.AppBarShipmentsSaved} />
          
          <GridHeaderFilter container direction="row" justify="center" alignItems="center">
            <Grid item container md={12} direction="row">
              <Grid item md={6} className="text-align-left">
                <Typography className="typography-generic bigweight text-align-left">{localizer.FindShipments}</Typography>
              </Grid>
              <Grid item md={6} className="text-align-right">
                <Button className="button-generic filter" variant="outlined" onClick={this.doFilter} startIcon={<i className="fa-solid fa-filter"></i>}>
                  {localizer.Filter}
                </Button>
                <Button className="button-generic filter" variant="outlined" onClick={this.doCleanFilters} startIcon={<i className="fa-solid fa-broom"></i>}>
                  {localizer.CleanFilter}
                </Button>
              </Grid>
            </Grid>

            {/* first line filter */}
            <Grid container item md={12} spacing={2}>
              {this.state.session && (this.state.session.role === Roles.ROLE_ADMIN.Name || this.state.session.role === Roles.ROLE_SUPERVISOR.Name) &&
                <Grid item md={3}>
                  <Select className='typography-generic p-0' style={{ borderRadius: 0, height: 35, backgroundColor: 'white' }}
                    id="users"
                    fullWidth
                    MenuProps={{
                      classes: { paper: "max-height-500" },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left"
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left"
                      },
                      getContentAnchorEl: null
                    }}
                    variant="outlined"
                    value={this.state.usersSelected}
                    multiple
                    onChange={this.handleChangeUser}
                    renderValue={(selected) => selected.map((x) => x.userEmail.toLowerCase()).join(', ')}
                  >
                    <MenuItem className="border-bottom-1-solid-primary  p-0" key="allUsers" value="allUsers" data-modal="allUsers">
                      <Checkbox
                        checked={this.state.isAllUsersSelected}
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                      <ListItemText
                        primary={<Typography className="typography-generic font-weight-bold">{this.state.isAllUsersSelected ? localizer.UnSelectAll : localizer.SelectAll}</Typography>}
                      />
                      <hr className="hr-custom" />
                    </MenuItem>

                    {this.state.users.map((user) => (
                      <MenuItem key={user.userId} value={user} data-modal={user.userId} className="pt-0 pb-0">
                        <Checkbox
                          color="primary"
                          //checked={this.state.showItemsSelected.includes(showItem) ? true : false}
                          checked={this.state.usersSelected ? this.state.usersSelected.find(s => s.userId === user.userId) ? true : false : false}
                          icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                          checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                        />
                        <ListItemText primary={<Typography className="typography-generic">{user.userEmail.toLowerCase()}</Typography>} />
                      </MenuItem>
                    ))}
                  </Select>

                </Grid>
              }
              <Grid item md={2}>
                <TextFieldStyled id="shipmentCode" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.Shipment}</Typography>}
                  name="shipmentCode" variant="outlined" value={this.state.filters.shipmentCode ? this.state.filters.shipmentCode : ""}
                  fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic width-120 textinline "
                    }
                  }}
                />
              </Grid>
              <Grid item md={3}>
                <Select className='typography-generic p-0' style={{ borderRadius: 0, height: 35, backgroundColor: 'white' }}
                  id="products"
                  fullWidth
                  MenuProps={{
                    classes: { paper: "max-height-500" },
                    anchorOrigin: {
                      vertical: "bottom",
                      horizontal: "left"
                    },
                    transformOrigin: {
                      vertical: "top",
                      horizontal: "left"
                    },
                    getContentAnchorEl: null
                  }}
                  variant="outlined"
                  value={this.state.productSelected}
                  multiple
                  onChange={this.handleChangeProduct}
                  renderValue={(selected) => selected.map((x) => x.description).join(', ')}
                >
                  <MenuItem className="border-bottom-1-solid-primary p-0" key="allProducts" value="allProducts" data-modal="allProducts">
                    <Checkbox
                      checked={this.state.isAllProductsSelected}
                      icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                      checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                    />
                    <ListItemText
                      primary={<Typography className="typography-generic font-weight-bold">{this.state.isAllProductsSelected ? localizer.UnSelectAll : localizer.SelectAll}</Typography>}
                    />
                    
                    <hr className="hr-custom" />
                  </MenuItem>
                  {this.state.products.map((product) => (
                    <MenuItem key={product.productCode} value={product} data-modal={product.productCode} className="pt-0 pb-0">
                      <Checkbox
                        color="primary"
                        //checked={this.state.showItemsSelected.includes(showItem) ? true : false}
                        checked={this.state.productSelected ? this.state.productSelected.find(p => p.productCode === product.productCode) ? true : false : false}
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                      <ListItemText primary={<Typography className="typography-generic">{product.description}</Typography>} />
                    </MenuItem>
                  ))}
                </Select>
               
              </Grid>
              <Grid item md={4}>
                <TextFieldStyled id="reference" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.Reference}</Typography>}
                  name="reference" variant="outlined" value={this.state.filters.reference ? this.state.filters.reference : ""}
                  fullWidth
                  InputProps={{
                    classes: {
                      input: "typography-generic width-120 textinline pt-0 pb-0"
                    }
                  }}
                />
              </Grid>
            </Grid>
            
            {/* collapse more filter */}
            <Collapse in={this.state.open} timeout="auto" unmountOnExit style={{ width: "100%" }}>
              <Grid container item md={12} direction="row" justify="center">
                <Grid item md={4} className="p-8">
                  <TextFieldStyled id="who" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.InboxDestination}</Typography>}
                    name="who" variant="outlined" value={this.state.filters.who ? this.state.filters.who : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={4} className="p-8">
                  <TextFieldStyled id="streetName" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.StreetName}</Typography>}
                    name="streetName" variant="outlined" value={this.state.filters.streetName ? this.state.filters.streetName : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={2} className="p-8">
                  <TextFieldStyled id="postalCode" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.PostalCode}</Typography>}
                    name="postalCode" variant="outlined" value={this.state.filters.postalCode ? this.state.filters.postalCode : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
                <Grid item md={2} className="p-8">
                  <TextFieldStyled id="locality" onChange={this.onInputchange} label={<Typography className="typography-generic">{localizer.Locality}</Typography>}
                    name="locality" variant="outlined" value={this.state.filters.locality ? this.state.filters.locality : ""}
                    fullWidth
                    InputProps={{
                      classes: {
                        input: "typography-generic textinline pt-0 pb-0"
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Collapse>

            <Grid item md={12} className="text-align-right p-10">
              <label >{this.state.open ? localizer.ExpandLessFilter : localizer.ExpandMoreFilter}</label>
              <IconButton aria-label="expand row" size="small" onClick={this.setOpen}>
                {this.state.open ? <i className="fa-solid fa-angle-up font-size-20"></i> : <i className="fa-solid fa-angle-down font-size-20"></i>}
              </IconButton>
            </Grid>
          </GridHeaderFilter>
          <Grid container direction="row" justify="center" alignItems="center">
            <Grid container justify="flex-start" alignitems="flex-start">

              <Grid item md={6}>
                {localizer.TotalShipments}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.totalShipments)}</b> &nbsp;&nbsp;{localizer.TotalDisplayed}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.shipments.length)}</b>&nbsp;&nbsp;{localizer.TotalSelected}:&nbsp;<b>{CurrencyCustom.numberFormatter(this.state.shipmentsCodesSelected.length)}</b>
              </Grid>
              <Grid item md={6} className="text-align-right">
                <Button className="button-generic downloadTable" variant="contained" onClick={this.downloadExcel} startIcon={<i className="fa-solid fa-file-excel"></i>}>
                  {localizer.OutboxDownloadExcel}
                </Button>
              </Grid>
              
            </Grid>
            <TableContainer component={Paper}>
              <TableStyled aria-label="collapsible table">
                <TableHead>
                  <TableRowHeaderStyled>
                    <TableCellStyled align="center">
                      <Checkbox
                        checked={this.state.checkedAll}
                        onChange={this.onChangeSelectAll}
                        name="checkedAll"
                        color="primary"
                        icon={<i className="fa-regular fa-square font-size-25 color-primary"></i>}
                        checkedIcon={<i className="fa-solid fa-square-check font-size-25 color-primary"></i>}
                      />
                    </TableCellStyled>
                    <TableCellStyled />
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Shipment}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Type}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.User}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Reference}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Sent}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Addressee}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Status}</Typography></TableCellStyled>
                    <TableCellStyled align="center"><Typography className="typography-generic tablerow-header">{localizer.Actions}</Typography></TableCellStyled>
                   
                  </TableRowHeaderStyled>
                </TableHead>
                <TableBody>
                  {(this.state.shipments && this.state.shipments.length > 0) ? this.state.shipments.map((shipment) => (
                    <ShipmentSavedRow key={shipment.shipmentId}
                      removeOrCancelShipment={this.removeOrCancelShipment}
                      shipment={shipment}
                      products={this.state.products}
                      currentUser={this.state.session.userEmail}
                      shipmentsCodesSelected={this.state.shipmentsCodesSelected}
                      checked={this.state.checkedAll}
                      addOrRemoveSelectedShipment={this.addOrRemoveSelectedShipment} />
                  )) :
                    <TableRowStyled><TableCellStyled colSpan={12} className="typography-generic tablerow-content font-weight-bold" align="center">{this.state.isLoading ? localizer.WaitingData : localizer.NotFound}</TableCellStyled></TableRowStyled>
                  }
                </TableBody>
              </TableStyled>
            </TableContainer>
          </Grid>
          <Grid container direction="row" justify="flex-end" alignItems="center" style={{ paddingTop: 25 }}>
            <Grid item>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, flexWrap: 'nowrap' }}>
                <span className="typography-generic">
                  {localizer.RowsPerPage || "Envíos por página"}:
                </span>
                <Select
                  value={this.state.pageSize}
                  onChange={this.handleChangeRowsPerPage}
                  variant="outlined"
                  className="typography-generic"
                  style={{ height: 35, backgroundColor: 'white', minWidth: 88 }}
                  renderValue={(selected) => <span className="typography-generic">{selected}</span>}
                >
                  {SHIPMENT_PAGE_SIZE_OPTIONS.map((option) => (
                    <MenuItem key={option} value={option}>
                      <Typography className="typography-generic">{option}</Typography>
                    </MenuItem>
                  ))}
                </Select>
                <Pagination
                  count={totalPages}
                  page={currentPage}
                  // UI page is 1-based; convert back to internal 0-based page index.
                  onChange={(event, page) => this.handleChangePage(page - 1)}
                  shape="rounded"
                  color="primary"
                  showFirstButton
                  showLastButton
                  size="small"
                  renderItem={(item) => (
                    <PaginationItem
                      {...item}
                      className="typography-generic"
                      style={item.selected ? { backgroundColor: 'var(--custom-primary-color)', color: '#ffffff' } : null}
                    />
                  )}
                />
              </div>
            </Grid>
          </Grid>
        </Container>

        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.shipmentsError} severity="error" handleonClose={this.handleonClose} />
    
        {/* Upload draft error. */}
        <SnackbarCustom message={this.state.shipmentRemoveError} severity="error" handleonClose={this.handleonClose} />

        {/* Waiting for service response. */}
        {this.state.isLoading &&
          <Backdrop open={this.state.isLoading} style={{ zIndex: 100 }}>
            <CircularProgress color="secondary" />
          </Backdrop>
        }
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/shipment-saved/ShipmentsSavedLayout.js